// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Option$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/radio-group/Option.bs.js";
import * as TransactionType from "../../../../app/wallet/entity/TransactionType.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTitleBar$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormTitleBar.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function validateAmountMaxLimit(error, maxLimit, amount) {
  if (amount < 0.0 || amount > maxLimit) {
    return {
            TAG: /* Error */1,
            _0: error
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: amount
          };
  }
}

function validateDebitTxnAmount(debitReason, amount) {
  return Belt_Option.mapWithDefault(debitReason, {
              TAG: /* Ok */0,
              _0: amount
            }, (function (reason) {
                var match = reason.text;
                switch (match) {
                  case "Insurance Premium (Full)" :
                  case "Other Debit" :
                  case "Wallet Migration Debit" :
                      return {
                              TAG: /* Ok */0,
                              _0: amount
                            };
                  default:
                    return validateAmountMaxLimit("Limit of 5500 on some DEBIT transactions", 5500, amount);
                }
              }));
}

var validators_partner_comment = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      return PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* String */1,
                  _0: param.partner_comment
                });
    })
};

var validators_admin_comment = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      return PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* String */1,
                  _0: param.admin_comment
                });
    })
};

var validators_amount = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var transactionReason = param.transactionReason;
      var transactionType = param.transactionType;
      var amountResult = PrimitiveFormTypes$Catalyst.getValue({
            TAG: /* Float */3,
            _0: param.amount
          });
      if (transactionType === undefined) {
        return Belt_Result.flatMap(amountResult, (function (a) {
                      return {
                              TAG: /* Ok */0,
                              _0: a
                            };
                    }));
      }
      var match = TransactionType.fromString(transactionType.value);
      if (match) {
        return Belt_Result.flatMap(amountResult, (function (param) {
                      return validateDebitTxnAmount(transactionReason, param);
                    }));
      } else {
        return Belt_Result.flatMap(amountResult, (function (param) {
                      return validateAmountMaxLimit("Limit of 2000 on CREDIT transactions", 2000, param);
                    }));
      }
    })
};

var validators_transactionReason = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var transactionReason = param.transactionReason;
      if (transactionReason !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: transactionReason
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Select Tranasction Reason"
              };
      }
    })
};

var validators_transactionType = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var transactionType = param.transactionType;
      if (transactionType !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: TransactionType.fromString(transactionType.value)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Select Tranasction type"
              };
      }
    })
};

var validators = {
  partner_comment: validators_partner_comment,
  admin_comment: validators_admin_comment,
  amount: validators_amount,
  transactionReason: validators_transactionReason,
  transactionType: validators_transactionType
};

function initialFieldsStatuses(_input) {
  return {
          partner_comment: /* Pristine */0,
          admin_comment: /* Pristine */0,
          amount: /* Pristine */0,
          transactionReason: /* Pristine */0,
          transactionType: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.partner_comment;
  var match_0 = match ? match._0 : Curry._1(validators.partner_comment.validate, input);
  var match$1 = fieldsStatuses.admin_comment;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.admin_comment.validate, input);
  var match$2 = fieldsStatuses.amount;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.amount.validate, input);
  var match$3 = fieldsStatuses.transactionReason;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.transactionReason.validate, input);
  var match$4 = fieldsStatuses.transactionType;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.transactionType.validate, input);
  var partner_commentResult = match_0;
  var partner_commentResult$1;
  if (partner_commentResult.TAG === /* Ok */0) {
    var admin_commentResult = match_0$1;
    if (admin_commentResult.TAG === /* Ok */0) {
      var amountResult = match_0$2;
      if (amountResult.TAG === /* Ok */0) {
        var transactionReasonResult = match_0$3;
        if (transactionReasonResult.TAG === /* Ok */0) {
          var transactionTypeResult = match_0$4;
          if (transactionTypeResult.TAG === /* Ok */0) {
            return {
                    TAG: /* Valid */0,
                    output: {
                      transactionType: transactionTypeResult._0,
                      transactionReason: transactionReasonResult._0,
                      amount: amountResult._0,
                      admin_comment: admin_commentResult._0,
                      partner_comment: partner_commentResult._0
                    },
                    fieldsStatuses: {
                      partner_comment: /* Dirty */{
                        _0: partner_commentResult,
                        _1: /* Shown */0
                      },
                      admin_comment: /* Dirty */{
                        _0: admin_commentResult,
                        _1: /* Shown */0
                      },
                      amount: /* Dirty */{
                        _0: amountResult,
                        _1: /* Shown */0
                      },
                      transactionReason: /* Dirty */{
                        _0: transactionReasonResult,
                        _1: /* Shown */0
                      },
                      transactionType: /* Dirty */{
                        _0: transactionTypeResult,
                        _1: /* Shown */0
                      }
                    },
                    collectionsStatuses: undefined
                  };
          }
          partner_commentResult$1 = partner_commentResult;
        } else {
          partner_commentResult$1 = partner_commentResult;
        }
      } else {
        partner_commentResult$1 = partner_commentResult;
      }
    } else {
      partner_commentResult$1 = partner_commentResult;
    }
  } else {
    partner_commentResult$1 = partner_commentResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            partner_comment: /* Dirty */{
              _0: partner_commentResult$1,
              _1: /* Shown */0
            },
            admin_comment: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            amount: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            transactionReason: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            transactionType: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurPartner_commentField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.partner_comment, validators_partner_comment, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  partner_comment: status,
                                  admin_comment: init.admin_comment,
                                  amount: init.amount,
                                  transactionReason: init.transactionReason,
                                  transactionType: init.transactionType
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAdmin_commentField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.admin_comment, validators_admin_comment, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  partner_comment: init.partner_comment,
                                  admin_comment: status,
                                  amount: init.amount,
                                  transactionReason: init.transactionReason,
                                  transactionType: init.transactionType
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAmountField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.amount, validators_amount, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  partner_comment: init.partner_comment,
                                  admin_comment: init.admin_comment,
                                  amount: status,
                                  transactionReason: init.transactionReason,
                                  transactionType: init.transactionType
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTransactionReasonField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.transactionReason, validators_transactionReason, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  partner_comment: init.partner_comment,
                                  admin_comment: init.admin_comment,
                                  amount: init.amount,
                                  transactionReason: status,
                                  transactionType: init.transactionType
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTransactionTypeField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.transactionType, validators_transactionType, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  partner_comment: init.partner_comment,
                                  admin_comment: init.admin_comment,
                                  amount: init.amount,
                                  transactionReason: init.transactionReason,
                                  transactionType: status
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */5 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */5,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */6,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */8);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */7);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */6 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */7 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */8 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdatePartner_commentField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.partner_comment, state.submissionStatus, validators_partner_comment, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            partner_comment: status,
                                            admin_comment: init.admin_comment,
                                            amount: init.amount,
                                            transactionReason: init.transactionReason,
                                            transactionType: init.transactionType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAdmin_commentField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.admin_comment, state.submissionStatus, validators_admin_comment, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            partner_comment: init.partner_comment,
                                            admin_comment: status,
                                            amount: init.amount,
                                            transactionReason: init.transactionReason,
                                            transactionType: init.transactionType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAmountField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.amount, state.submissionStatus, validators_amount, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            partner_comment: init.partner_comment,
                                            admin_comment: init.admin_comment,
                                            amount: status,
                                            transactionReason: init.transactionReason,
                                            transactionType: init.transactionType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTransactionReasonField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$5 = Formality.validateDependentFieldOnChange(nextInput$3, nextFieldsStatuses.contents.amount, validators_amount, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  partner_comment: init.partner_comment,
                                  admin_comment: init.admin_comment,
                                  amount: status,
                                  transactionReason: init.transactionReason,
                                  transactionType: init.transactionType
                                };
                        }));
                  if (result$5 !== undefined) {
                    nextFieldsStatuses.contents = result$5;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, nextFieldsStatuses.contents.transactionReason, state.submissionStatus, validators_transactionReason, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            partner_comment: init.partner_comment,
                                            admin_comment: init.admin_comment,
                                            amount: init.amount,
                                            transactionReason: status,
                                            transactionType: init.transactionType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTransactionTypeField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$6 = Formality.validateDependentFieldOnChange(nextInput$4, nextFieldsStatuses$1.contents.transactionReason, validators_transactionReason, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  partner_comment: init.partner_comment,
                                  admin_comment: init.admin_comment,
                                  amount: init.amount,
                                  transactionReason: status,
                                  transactionType: init.transactionType
                                };
                        }));
                  if (result$6 !== undefined) {
                    nextFieldsStatuses$1.contents = result$6;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, nextFieldsStatuses$1.contents.transactionType, state.submissionStatus, validators_transactionType, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            partner_comment: init.partner_comment,
                                            admin_comment: init.admin_comment,
                                            amount: init.amount,
                                            transactionReason: init.transactionReason,
                                            transactionType: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */5 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */6 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */7 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updatePartner_comment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePartner_commentField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAdmin_comment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAdmin_commentField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAmount: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAmountField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTransactionReason: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTransactionReasonField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTransactionType: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTransactionTypeField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurPartner_comment: (function (param) {
              return Curry._1(dispatch, /* BlurPartner_commentField */0);
            }),
          blurAdmin_comment: (function (param) {
              return Curry._1(dispatch, /* BlurAdmin_commentField */1);
            }),
          blurAmount: (function (param) {
              return Curry._1(dispatch, /* BlurAmountField */2);
            }),
          blurTransactionReason: (function (param) {
              return Curry._1(dispatch, /* BlurTransactionReasonField */3);
            }),
          blurTransactionType: (function (param) {
              return Curry._1(dispatch, /* BlurTransactionTypeField */4);
            }),
          partner_commentResult: Formality.exposeFieldResult(state.fieldsStatuses.partner_comment),
          admin_commentResult: Formality.exposeFieldResult(state.fieldsStatuses.admin_comment),
          amountResult: Formality.exposeFieldResult(state.fieldsStatuses.amount),
          transactionReasonResult: Formality.exposeFieldResult(state.fieldsStatuses.transactionReason),
          transactionTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.transactionType),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.partner_comment || match.admin_comment || match.amount || match.transactionReason || match.transactionType) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */5);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */6);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */7);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */7,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */8);
            })
        };
}

var TransactionForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getTransactionTypeItems(param) {
  return List.map((function (txnType) {
                var statusString = TransactionType.toString(txnType);
                return {
                        key: statusString.toLowerCase(),
                        value: statusString,
                        text: statusString
                      };
              }), {
              hd: /* Credit */0,
              tl: {
                hd: /* Debit */1,
                tl: /* [] */0
              }
            });
}

function PartnerWalletAdminTransactionForm$AdminTransactionFormBody(Props) {
  var createAdminTransaction = Props.createAdminTransaction;
  var transactionReasons = Props.transactionReasons;
  var error = Props.error;
  var match = CountryContext.useContext(undefined);
  var getTransactionReasons = function (transactionType) {
    if (transactionType === undefined) {
      return /* [] */0;
    }
    if (transactionType.value === "") {
      return /* [] */0;
    }
    var match = TransactionType.fromString(transactionType.value);
    if (match) {
      return Option$Catalyst.toSelectOption(transactionReasons.debit);
    } else {
      return Option$Catalyst.toSelectOption(transactionReasons.credit);
    }
  };
  var transactionOptions = getTransactionTypeItems(undefined);
  var form = useForm({
        transactionType: undefined,
        transactionReason: undefined,
        amount: "",
        admin_comment: "",
        partner_comment: ""
      }, (function (output, submissionCbs) {
          return Curry._2(createAdminTransaction, {
                      transactionType: output.transactionType,
                      transactionReason: Option$Catalyst.fromSelectOption(output.transactionReason),
                      amount: output.amount,
                      admin_comment: output.admin_comment,
                      partner_comment: output.partner_comment
                    }, (function (param) {
                        return Curry._1(submissionCbs.notifyOnSuccess, undefined);
                      }));
        }));
  return React.createElement("form", {
              className: "porter-form",
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  
                })
            }, React.createElement("div", {
                  className: "porter-form__section"
                }, React.createElement("div", {
                      className: "porter-form__row"
                    }, React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("Amount", (function ($$event) {
                                  return Curry._2(form.updateAmount, (function (input, value) {
                                                return {
                                                        transactionType: input.transactionType,
                                                        transactionReason: input.transactionReason,
                                                        amount: value,
                                                        admin_comment: input.admin_comment,
                                                        partner_comment: input.partner_comment
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.amountResult, undefined, undefined, undefined, undefined, {
                                className: "c-currency-end-adornment",
                                startAdornment: CountryConfig.getSymbol(match.country),
                                accept: undefined
                              }, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.amount
                          }
                        }), React.createElement(FormSelectInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("Transaction Type", (function ($$event) {
                                  Curry._2(form.updateTransactionType, (function (input, value) {
                                          return {
                                                  transactionType: value,
                                                  transactionReason: undefined,
                                                  amount: input.amount,
                                                  admin_comment: input.admin_comment,
                                                  partner_comment: input.partner_comment
                                                };
                                        }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), transactionOptions));
                                  return Curry._2(form.updateAmount, (function (input, value) {
                                                return {
                                                        transactionType: input.transactionType,
                                                        transactionReason: input.transactionReason,
                                                        amount: value,
                                                        admin_comment: input.admin_comment,
                                                        partner_comment: input.partner_comment
                                                      };
                                              }), form.input.amount);
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.transactionTypeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            value: form.input.transactionType,
                            items: transactionOptions,
                            isNoneRequired: true
                          }
                        })), React.createElement("div", {
                      className: "porter-form__row"
                    }, React.createElement(FormSelectInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("Transaction Reason", (function ($$event) {
                                  return Curry._2(form.updateTransactionReason, (function (input, value) {
                                                return {
                                                        transactionType: input.transactionType,
                                                        transactionReason: value,
                                                        amount: input.amount,
                                                        admin_comment: input.admin_comment,
                                                        partner_comment: input.partner_comment
                                                      };
                                              }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), getTransactionReasons(form.input.transactionType)));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.transactionReasonResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            value: form.input.transactionReason,
                            items: getTransactionReasons(form.input.transactionType),
                            isNoneRequired: true
                          }
                        }), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("Admin comment", (function ($$event) {
                                  return Curry._2(form.updateAdmin_comment, (function (input, value) {
                                                return {
                                                        transactionType: input.transactionType,
                                                        transactionReason: input.transactionReason,
                                                        amount: input.amount,
                                                        admin_comment: value,
                                                        partner_comment: input.partner_comment
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.admin_commentResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.admin_comment
                          }
                        })), React.createElement("div", {
                      className: "porter-form__row"
                    }, React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("Partner comment", (function ($$event) {
                                  return Curry._2(form.updatePartner_comment, (function (input, value) {
                                                return {
                                                        transactionType: input.transactionType,
                                                        transactionReason: input.transactionReason,
                                                        amount: input.amount,
                                                        admin_comment: input.admin_comment,
                                                        partner_comment: value
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.partner_commentResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.partner_comment
                          }
                        }))), error !== undefined ? React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: error
                  }) : null, React.createElement("div", {
                  className: "porter-form__section"
                }, React.createElement("button", {
                      className: "btn-primary--green",
                      onClick: (function (param) {
                          return Curry._1(form.submit, undefined);
                        })
                    }, "Submit")));
}

var AdminTransactionFormBody = {
  getTransactionTypeItems: getTransactionTypeItems,
  make: PartnerWalletAdminTransactionForm$AdminTransactionFormBody
};

function getFormError(createTransactionStatus) {
  if (typeof createTransactionStatus === "number" || createTransactionStatus.TAG !== /* Error */2) {
    return ;
  } else {
    return createTransactionStatus._0;
  }
}

function isStaleDataError(error) {
  var match = error.title;
  return match === 4;
}

function PartnerWalletAdminTransactionForm$PartnerWalletAdminTransactionForm(Props) {
  var transactionReasons = Props.transactionReasons;
  var createPartnerWalletTransaction = Props.createPartnerWalletTransaction;
  var refreshWalletReport = Props.refreshWalletReport;
  var createTransactionStatus = Props.createTransactionStatus;
  var closeCreateTransactionModal = Props.closeCreateTransactionModal;
  var createAdminTransaction = function (adminTxnFormData, onSubmitCallback) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(createPartnerWalletTransaction, adminTxnFormData);
                }), (function (_data) {
                  Curry._1(onSubmitCallback, undefined);
                  Curry._1(closeCreateTransactionModal, undefined);
                  return Curry._1(refreshWalletReport, undefined);
                }), (function (_message) {
                  return Curry._1(onSubmitCallback, undefined);
                }));
  };
  var tmp;
  var exit = 0;
  if (typeof createTransactionStatus === "number") {
    exit = 1;
  } else {
    switch (createTransactionStatus.TAG | 0) {
      case /* Loading */0 :
          exit = 1;
          break;
      case /* Live */1 :
          tmp = "Partner Wallet Transaction created successfully";
          break;
      case /* Error */2 :
          if (isStaleDataError(createTransactionStatus._0._0)) {
            tmp = React.createElement("div", {
                  className: "u-text-centre u-padding-bottom-small u-padding-top-small"
                }, React.createElement("p", undefined, "Stale data error! "), React.createElement(Button$Catalyst.make, {
                      text: "REFRESH",
                      cb: (function (param) {
                          Curry._1(refreshWalletReport, undefined);
                          return Curry._1(closeCreateTransactionModal, undefined);
                        }),
                      className: "action-btn-form"
                    }));
          } else {
            exit = 1;
          }
          break;
      
    }
  }
  if (exit === 1) {
    tmp = React.createElement(PartnerWalletAdminTransactionForm$AdminTransactionFormBody, {
          createAdminTransaction: createAdminTransaction,
          transactionReasons: transactionReasons,
          error: getFormError(createTransactionStatus)
        });
  }
  return React.createElement("div", {
              className: "porter-form u-scrollable-y u-form-full-height"
            }, React.createElement(FormTitleBar$Catalyst.make, {
                  title: "Create Wallet Transaction",
                  onCloseCb: (function (param) {
                      return Curry._1(closeCreateTransactionModal, undefined);
                    })
                }), tmp);
}

var PartnerWalletAdminTransactionForm = {
  getFormError: getFormError,
  isStaleDataError: isStaleDataError,
  make: PartnerWalletAdminTransactionForm$PartnerWalletAdminTransactionForm
};

export {
  validateAmountMaxLimit ,
  validateDebitTxnAmount ,
  TransactionForm ,
  AdminTransactionFormBody ,
  PartnerWalletAdminTransactionForm ,
  
}
/* react Not a pure module */
